<template>
  <div class="row q-col-gutter-sm items-start q-mb-md">
    <q-checkbox
      v-if="currentSite.counterPickupEnabled"
      v-model="registerType.showCounterPickupOption"
      class="col-3"
      label="Show Counter Pickup Option"
      bottom-slots
    />
    <q-checkbox
      v-if="currentSite.expressPickupEnabled"
      v-model="registerType.showExpressPickupOption"
      class="col-3"
      label="Show Express Pickup Option"
      bottom-slots
    />
    <q-checkbox
      v-if="currentSite.tableDeliveryEnabled"
      v-model="registerType.showTableDeliveryOption"
      class="col-3"
      label="Show Table Delivery Option"
      bottom-slots
    />
    <q-checkbox
      v-if="currentSite.theaterSeatDeliveryEnabled"
      v-model="registerType.showTheaterSeatDeliveryOption"
      class="col-3"
      label="Show Theater Seat Delivery Option"
      bottom-slots
    />
  </div>
  <div class="row q-col-gutter-sm items-start">
    <q-select
      v-model="registerType.deliveryTypes"
      map-options
      emit-value
      multiple
      use-chips
      class="col-6"
      label="Custom Delivery Types"
      :options="$_.map($_.filter(deliveryTypes.data, deliveryType => (deliveryType.enable || $_.includes(registerType.deliveryTypes, deliveryType.id))), deliveryType => ({ value: deliveryType.id, label: deliveryType.name }))"
      bottom-slots
      @keyup.enter.stop
    />
    <q-select
      v-model="registerType.deliveryTypePriority"
      map-options
      emit-value
      multiple
      use-chips
      class="col-6"
      label="Delivery Priority"
      :options="registerType.deliveryTypeOptions"
      bottom-slots
      @keyup.enter.stop
    />
  </div>
  <div class="row q-col-gutter-sm items-start">
    <q-checkbox
      v-if="currentSite.tableDeliveryEnabled || currentSite.theaterSeatDeliveryEnabled"
      v-model="registerType.promptForDeliveryPositionOwner"
      data-class="col-3"
      label="Require Delivery Position Owner"
      bottom-slots
    >
      <q-tooltip>
        When enabled, the user will be prompted to select a delivery position owner from a list of available positions on the order.
      </q-tooltip>
    </q-checkbox>
    <q-checkbox
      v-if="currentSite.tableDeliveryEnabled || currentSite.theaterSeatDeliveryEnabled"
      v-model="registerType.allowStartTabWithDeliveryInfo"
      data-class="col-3"
      label="Allow Starting Tab with Delivery Information"
      bottom-slots
    >
      <q-tooltip>
        When starting a tab order, allow the tab to be started and identified with only the delivery information
      </q-tooltip>
    </q-checkbox>
    <q-checkbox
      v-model="registerType.allowRegisterDeliveryType"
      data-class="col-3"
      label="Allow Items to be Delivered from Register"
      bottom-slots
    >
      <q-tooltip>
        If enabled, items can be delivered from the register. This setting can be disabled when using a roaming delivery device.
      </q-tooltip>
    </q-checkbox>
  </div>
</template>
<script>
export default {
  name: 'RegisterTypeDeliveryOptions',
  props: {
    registerType: {
      type: Object,
      required: true
    }
  },
  configuration: ['currentSite', 'deliveryTypes']
}
</script>
